import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useAuth, errMsg } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import PasswordRules from "@/components/PasswordRules";

export default function ChangePassword() {
  const navigate = useNavigate();
  const { user, setPasswordChanged, logout } = useAuth();
  const [form, setForm] = useState({ current_password: "Panera1234!", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  if (user === false) { navigate("/login"); return null; }

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated. Welcome to The Spread!");
      setPasswordChanged();
      navigate("/app");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your password"
      subtitle="For security, you must set a new password before continuing."
      footer={<button onClick={() => { logout(); navigate("/login"); }} className="text-brand font-semibold hover:underline">Sign out</button>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="cur">Current password</Label>
          <Input id="cur" data-testid="change-current" type="password" value={form.current_password} onChange={set("current_password")} className="mt-1.5 border-brand-line bg-white" />
          <p className="text-xs text-brand-muted mt-1">Default is <span className="font-mono">Panera1234!</span></p>
        </div>
        <div>
          <Label htmlFor="new">New password</Label>
          <Input id="new" data-testid="change-new" type="password" value={form.new_password} onChange={set("new_password")} className="mt-1.5 border-brand-line bg-white" />
        </div>
        <div>
          <Label htmlFor="cf">Confirm new password</Label>
          <Input id="cf" data-testid="change-confirm" type="password" value={form.confirm} onChange={set("confirm")} className="mt-1.5 border-brand-line bg-white" />
        </div>
        <PasswordRules password={form.new_password} />
        <Button type="submit" data-testid="change-submit" disabled={loading} className="w-full rounded-full brand-btn h-11">
          {loading ? "Updating..." : "Set new password"}
        </Button>
      </form>
    </AuthShell>
  );
}
